import styled from '@emotion/styled';

export const SadaService = styled.div``;
